import { Box, Typography } from '@mui/material'
import { useI18n } from '@popety_io/popety-io-lib'
import TrainIcon from '@mui/icons-material/Train'
import DirectionsRailwayIcon from '@mui/icons-material/DirectionsRailway'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import BedtimeOutlinedIcon from '@mui/icons-material/BedtimeOutlined'

import { getNoiseColor } from '../utils/getNoiseColor'
import { ContentTitleItemRoot } from './NightAndDay.style'

const NightAndDay = ({ data }: { data: any }) => {
  const { t } = useI18n()

  const data1 = [
    {
      icon: (
        <WbSunnyIcon
          fontSize="large"
          sx={{
            color: '#FBD823',
          }}
        />
      ),
      title: t('common.jour'),
      maxNoiseTitle: t('estimate.Niveau bruit maximum jour'),
      dailyTrafic: data?.dailyTraficDay || '0',
      railway: data?.railwayDay || '0',
      maxNoise: data?.maxNoiseDay || '0',
    },
    {
      icon: <BedtimeOutlinedIcon fontSize="large" />,
      title: t('common.night'),
      maxNoiseTitle: t('estimate.Niveau bruit maximum nuit'),
      dailyTrafic: data?.maxNoiseNight || '0',
      railway: data?.railwayNight || '0',
      maxNoise: data?.maxNoiseNight || '0',
    },
  ]

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      {data1.map((item, key) => {
        return (
          <Box
            key={`noise_${key}`}
            display="flex"
            flexDirection="row"
            gap={8}
            fontWeight={500}
            flexWrap="wrap"
          >
            <Box display="flex" flexDirection="column" gap={2}>
              <Box display="flex" alignItems="center" gap={1}>
                {item.icon}
                <span style={{ textTransform: 'uppercase' }}>{item.title}</span>
              </Box>
              <Box>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  color="#969696"
                  justifyContent="space-between"
                >
                  <Box display="flex" gap={1}>
                    <TrainIcon />
                    <span>{t('common.daily_traffic')}</span>
                  </Box>
                  <span style={{ color: getNoiseColor(item.dailyTrafic) }}>
                    {item.dailyTrafic === 'N/A'
                      ? 'N/A'
                      : `${item.dailyTrafic} dB`}
                  </span>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  color="#969696"
                  justifyContent="space-between"
                >
                  <Box display="flex" gap={1}>
                    <DirectionsRailwayIcon />
                    <span>{t('common.ferroviaire')}</span>
                  </Box>
                  <span style={{ color: getNoiseColor(item.railway) }}>
                    {item.railway === 'N/A' ? 'N/A' : `${item.railway} dB`}
                  </span>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ContentTitleItemRoot>
                <Typography
                  variant="h4"
                  fontWeight={500}
                  color={getNoiseColor(item.maxNoise)}
                >
                  {item.maxNoise} dB
                </Typography>

                <Typography display="flex" alignItems="center">
                  {item.maxNoiseTitle}
                </Typography>
              </ContentTitleItemRoot>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default NightAndDay
